import React, { createRef, useEffect, useRef, useState } from 'react'
import * as routeLink from "./../../constants/routeLink";
import TopInfo from "./../../components/TopInfo/index";
import BalanceInfo from "./../../components/BalanceInfo/index";
import TopLevel from "./../../components/TopLevel/index";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { checkPercentMining, formatNumber, trups } from '../../services/services';
let prifitPerSecent = 0.000001;
const Index = (props) => {
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;
  const [scaling, setScaling] = useState(true);
  const [scalingValue, setscalingValue] = useState(0.8);
  const [bubbles, setBubbles] = useState([]);
  const bubbleContainerRef = useRef(null);
  const buttonRef = useRef(null);
  const addScore = 2;

  useEffect(() => {

    // console.log();
    if (user?.balanceMining * checkPercentMining(user?.balanceMining) / (30 * 24 * 60 * 60 * 100)) {
      prifitPerSecent = (user?.balanceMining * checkPercentMining(user?.balanceMining) / (30 * 24 * 60 * 60 * 100)).toFixed(6)
    }

  }, [user]);

  const handleClick = () => {
    const bubble = {
      id: Date.now(),
      text: "+" + prifitPerSecent,
      left: '50%', // Đặt từ giữa theo chiều ngang
      top: '-50%',  // Đặt từ giữa theo chiều dọc
    };
    setBubbles([...bubbles, bubble]);

    setTimeout(() => {
      setBubbles(bubbles => bubbles.filter(b => b.id !== bubble.id));
    }, 10000); // Thời gian bong bóng biến mất
  };

  useEffect(() => {
    // console.log(user);
    const intervalId = setInterval(() => {
      // console.log(user);

      handleClick();

    }, 800);
    let scalDefault = 0.8;
    const intervalsca = setInterval(() => {
      const bbb = buttonRef.current;
      const newscale = scalDefault += 0.04;
      if (scalDefault > 1) {
        scalDefault = 0.8
      }
      if (bbb) {
        bbb.style.transform = `scale(${newscale})`;
      }
      // setScaling(!scaling)
    }, 200);
    return () => {
      clearInterval(intervalId);
      clearInterval(intervalsca);
    }
  }, []);

  useEffect(() => {

    if (buttonRef.current) {
      buttonRef.current.style.transform = `scale(${scalingValue})`;
    }
  }, [scalingValue]);

  useEffect(() => {
    if (bubbleContainerRef.current) {
      // Remove all existing bubbles
      // bubbleContainerRef.current.innerHTML = '';

      // Append new bubbles
      bubbles.forEach(bubble => {
        const bubbleElement = document.createElement('div');
        bubbleElement.className = 'bubble expand';
        bubbleElement.style.left = `${bubble.left}%`;
        bubbleElement.style.top = `${bubble.top}%`;

        // Đặt vị trí trung tâm với giá trị ngẫu nhiên
        const centerX = 50; // Giữa phần tử chứa
        const centerY = 80; // Giữa phần tử chứa
        const randomX = (Math.random() - 0.5) * 500; // Giá trị từ -25% đến 25%
        const randomY = (Math.random() - 0.5) * 400; // Giá trị từ -50% đến 50%

        bubbleElement.style.left = `${centerX}%`;
        bubbleElement.style.top = `${centerY}%`;

        bubbleElement.style.setProperty('--random-x', `${randomX}px`);
        bubbleElement.style.setProperty('--random-y', `${randomY}px`);
        bubbleElement.textContent = bubble.text;
        bubbleContainerRef?.current?.appendChild(bubbleElement);

        // Xóa phần tử sau khi hiệu ứng hoàn thành
        setTimeout(() => {
          bubbleContainerRef?.current?.removeChild(bubbleElement);
        }, 3000); // Thời gian giống như thời gian của animation
      });
    }
  }, [bubbles]);


  const navigate = useNavigate();
  return (
    <div className='d-flex justify-content-center align-items-center flex-column position-relative'>


      <TopInfo />
      <TopLevel />


      <BalanceInfo />
      <div style={{ margin: 20,zIndex:2 }}>
        <div className='w-100 d-flex justify-content-center align-items-center flex-column p-1 '>


          <button type='button' className='w-100 scale_btn btn-game-touch '>
            <img src={`${routeLink.domain}/assets/nfts/${checkPercentMining(user?.balanceMining) * 1 + trups}.png`} style={{ transition: "all 0.2s linear", width: '100%' }} ref={buttonRef} />
            <div id='buble-w' className='' ref={bubbleContainerRef}>
            </div>
          </button>

          {/* <div className='w-75 d-flex justify-content-center align-items-center p-2 bottom-btnmain'>
  <div className='card-custom  p-2 radius-custom d-flex flex-column justify-content-center align-items-center mx-2'>
    <div className='d-flex justify-content-center align-items-center'>
      <button className='btn btn-custom-sm mt-1 scale_btn btn-balance p-0  '> <img className='w-100 h-100' src={`${routeLink.domain}/assets/nfts/${checkPercentMining(user?.balanceMining)}.png`} /></button>
      <h4 className='text-white  d-flex m-0 mx-2'>1500/1500</h4>


    </div>

  </div>

  <div className='card-custom p-2 radius-custom d-flex flex-column justify-content-center align-items-center'>
    <button className='bg-unset border-unset d-flex scale_btn justify-content-center align-items-center' onClick={() => {
      navigate(routeLink.BOOST);
    }}>
      <span className='btn btn-custom-sm mt-1 btn-balance p-0  '> <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} /></span>
      <h4 className='text-white d-flex m-0 mx-2'>BOOST</h4>


    </button>

  </div>
</div> */}

          {/* {bubbles.map(bubble => (
<div
  key={bubble.id}
  className="bubble expand"
  style={{ left: bubble.left, top: bubble.top }}
>
  {bubble.text}
</div>
))} */}
        </div>
      </div>
      <div>
        <div className="bg"></div>

        <div className="star-field">
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
        </div>
      </div>
    </div>
  )
}

export default Index;
